import { useRef, useEffect, EffectCallback } from 'react';
import { isEqual } from 'lodash';

function useDeepCompareMemoize(value: any) {
  const ref = useRef();
  const signalRef = useRef(0);

  if (!isEqual(value, ref.current)) {
    ref.current = value;
    signalRef.current += 1;
  }

  return [signalRef.current];
}

/**
 * The hook called only on deep change in dependencies.
 *
 * @param {Function} callback The callback function.
 * @param {*} dependencies The array to deep equality test.
 */
export const useDeepEffect = (callback: EffectCallback, dependencies: any[]) => (
  useEffect(callback, useDeepCompareMemoize(dependencies))
);
